import FullTemplate from "../../components/Assembler/JSON/FullTemplate";

import PictureInPicture from "../../components/Assembler/JSON/PictureInPicture";

import ScreenShareService from "../../infrastructure/Services/ScreenShareService";

import { ITypeMedia } from "../../interfaces/Artists";

import type Cameras from "../Devices/Cameras";

import { v4 as uuidv4 } from "uuid";

class GamerAdapterModel {
  private Model = PictureInPicture;

  private Cameras: Cameras | null = null;

  // biome-ignore lint/complexity/noUselessConstructor: <explanation>

  constructor() {
    this.Model.id = uuidv4();
  }

  async setCameras(cameras: Cameras) {
    this.Cameras = cameras;

    await this.setHardware();
  }

  private async setHardware() {
    // Camera by default

    const defaultCamera = this.getDefaultCamera();

    const haveCamera = defaultCamera !== null;

    if (!haveCamera) {
      this.Model = FullTemplate;
    }

    // Display by default

    const { defaultDisplay } = await this.getDefaultDisplay();

    // Area of background

    const areaBackground = this.Model.areas[0];

    // Apply camera to background

    areaBackground.media.resource = {
      id: defaultDisplay.id,

      type: ITypeMedia.display,

      source: {
        sourceId: defaultDisplay.id,

        width: defaultDisplay.width,

        height: defaultDisplay.height,
      },

      settings: {
        volume: 0,
      },
    };

    if (haveCamera) {
      const areaDisplay = this.Model.areas[1];

      areaDisplay.media.resource = {
        id: defaultCamera.id,

        type: ITypeMedia.camera,

        source: {
          deviceId: defaultCamera.deviceId,

          groupId: defaultCamera.groupId,

          kind: defaultCamera.kind,

          label: defaultCamera.label,
        },
      };

      this.Model.areas = [areaBackground, areaDisplay];
    } else {
      this.Model.areas = [areaBackground];
    }
  }

  private getDefaultCamera() {
    const cameras = this.Cameras?.getAll();

    const device = cameras?.[0] ?? null;

    const cameraDefault = device;

    const defaultInfoDevice = {
      id: cameraDefault?.id || "",

      deviceId: cameraDefault?.deviceInfo.deviceId || "",

      groupId: cameraDefault?.deviceInfo.groupId || "",

      kind: cameraDefault?.deviceInfo.kind || "",

      label: cameraDefault?.deviceInfo.label || "",
    };

    const haveCamera = defaultInfoDevice.label !== "OBS Virtual Camera";

    return cameraDefault && haveCamera ? defaultInfoDevice : null;
  }

  private async getDefaultDisplay() {
    const displayService = new ScreenShareService("api");

    const displays = await displayService.getSources();

    const defaultDisplay = displays[0];

    return {
      defaultDisplay,
    };
  }

  getModel() {
    return this.Model;
  }
}

export default GamerAdapterModel;
